export interface Role {
  id: number;
  role?: string;
  name?: string;
  level?: string;
  permissions?: string;
  access?: string;
  allPermissions?: boolean;
  protected?: boolean;
  state?: string;
}
